import React, { createContext, useReducer } from "react";

const initialState = {
    MyRemoteMuteState: false,
    MyRemoteVidState: false,
    MyRemotePalamiState: false,
    MyRemoteRoomState: false,
    hardMute: false,

};


const ACTIONS = {
    CLEAR: "clear",
    UPDATE_ALL: "update",
    UPDATE_ONE: "update",
}




const reducer = (state, action) => {
  switch (action.type) {
    
    case ACTIONS.UPDATE_ALL:
      return {...action.payload}
    case ACTIONS.UPDATE_ONE:   
      return { ...state, [action.payload.name]: action.payload.value }; 
    default:
      return state;
  }
};

const RunSessContext = createContext(initialState);

const RunSessProvider = props => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <RunSessContext.Provider value={{ state, dispatch }}>
      {props.children}
    </RunSessContext.Provider>
  );
};

export { RunSessContext, RunSessProvider, ACTIONS};
